import { add } from 'lodash';
import {
  FETCH_PROCESSORS_START,
  FETCH_PROCESSORS_SUCCESS,
  FETCH_PROCESSORS_ERROR,
  FETCH_PROCESSOR_START,
  FETCH_PROCESSOR_SUCCESS,
  FETCH_PROCESSOR_ERROR,
  FETCH_PROCESSOR_TRANS_STATS_START,
  FETCH_PROCESSOR_TRANS_STATS_SUCCESS,
  FETCH_PROCESSOR_TRANS_STATS_ERROR,
  ADD_PROCESSOR_START,
  ADD_PROCESSOR_SUCCESS,
  ADD_PROCESSOR_ERROR,
  DELETE_PROCESSOR_START,
  DELETE_PROCESSOR_ERROR,
  DELETE_PROCESSOR_SUCCESS,
  UPDATE_PROCESSOR_START,
  UPDATE_PROCESSOR_ERROR,
  UPDATE_PROCESSOR_SUCCESS,
  INDEX_PAGE_SIZE_DEFAULT,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  allProcessors: {
    data: [],
    loading: false,
    error: null,
    currentPage: 1,
    pageSize: INDEX_PAGE_SIZE_DEFAULT,
    totalItems: 0
  },
  transStats: {
    data: [],
    currentPage: 1,
    pageSize: INDEX_PAGE_SIZE_DEFAULT,
    totalRecords: 0,
  },
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PROCESSOR_START: {
      return {
        ...state,
        loading: true,
      };
    }
    case FETCH_PROCESSOR_SUCCESS: {
      return {
        ...state,
        loading: false,
        item: action.payload,
      };
    }
    case FETCH_PROCESSOR_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }

    case FETCH_PROCESSOR_TRANS_STATS_START: {
      return {
        ...state,
        transStats: {
          ...state.transStats,
          loading: true,
        },
      };
    }

    case FETCH_PROCESSOR_TRANS_STATS_ERROR: {
      return {
        ...state,
        transStats: {
          ...state.transStats,
          loading: false,
          error: action.payload,
        },
      };
    }



    case FETCH_PROCESSORS_START: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          loading: true
        },
      };
    }
    case FETCH_PROCESSORS_ERROR: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          loading: false,
          error: action.payload,
        },
      };
    }
    case FETCH_PROCESSORS_SUCCESS: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          loading: false,
          data: action.payload.data,
          totalItems: action.payload.totalItems,
          currentPage: action.payload.currentPage,
          pageSize: action.payload.pageSize,
        },
      };
    }

    case FETCH_PROCESSOR_TRANS_STATS_SUCCESS: {
      return {
        ...state,
        transStats: {
          ...state.transStats,
          data: action.payload,
          meta: {
            ...state.transStats.meta,
            ...action.meta,
          },
          loading: false,
        },
      };
    }

    case ADD_PROCESSOR_START: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          addingProcessor: true,
        },
      };
    }

    case ADD_PROCESSOR_SUCCESS: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          addingProcessor: false,
          data: [action.payload, ...state.allProcessors.data],
        },
      };
    }

    case ADD_PROCESSOR_ERROR: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          addingProcessor: false,
        },
      };
    }

    case UPDATE_PROCESSOR_START: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          updatingProcessor: true,
        },
      };
    }

    case UPDATE_PROCESSOR_SUCCESS: {
      const allProcessors = state.allProcessors.data;
      const updatedData = allProcessors.filter(
        (processor) => processor._id !== action.payload._id,
      );
      updatedData.push(action.payload);
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          updatingProcessor: false,
          data: updatedData,
        },
      };
    }

    case UPDATE_PROCESSOR_ERROR: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          updatingProcessor: false,
        },
      };
    }

    case DELETE_PROCESSOR_START: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          deletingProcessor: true,
        },
      };
    }

    case DELETE_PROCESSOR_SUCCESS: {
      const updatedData = state.allProcessors.data.filter(
        (type) => type._id !== action.payload,
      );

      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          deletingProcessor: false,
          data: updatedData,
        },
      };
    }

    case DELETE_PROCESSOR_ERROR: {
      return {
        ...state,
        allProcessors: {
          ...state.allProcessors,
          deletingProcessor: false,
        },
      };
    }


    default:
      return state;
  }
};
